import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const ProtectedRoute = ({ component: Comp, loggedIn, path, ...rest }) => {
    const { auth } = rest;
    
    return (
        <Route
            {...rest}

            render={props => {
                return auth ? (
                    <Comp {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: {
                                prevLocation: path,
                                error: "You need to login first!"
                            }
                        }}
                    />
                );
            }}
        />
    );
};

const mapStateToProps = state => {
    const { auth } = state.auth;
    return {
        auth
    };
};

export default connect(mapStateToProps)(ProtectedRoute);
